import React, { useEffect, useState } from "react";
import reportAPI from "../../api/reportAPI";
import { LoadingSpinner, ErrorMessage } from "../../components/common/ErrorComponents";

const TrendingQueriesWidget = ({ days = 7, limit = 10 }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await reportAPI.getTrendingQueries(days, limit);
        setData(response);
      } catch (err) {
        setError("Failed to load trending queries");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [days, limit]);

  if (loading) return <LoadingSpinner message="Loading trending queries..." />;
  if (error) return <ErrorMessage message={error} />;

  return (
    <div className="dashboard-widget">
      <p><strong className="mb-2">Trending Search Queries</strong></p>
      <ol className="lst-unstyled">
        {data.map((item, idx) => (
          <li key={idx}>
            {item._id} <span style={{color: '#888'}}>({item.count})</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default TrendingQueriesWidget;
